export const LAST_UPDATE = '2026-01-01';